var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRifacebookfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.5H17L18 9.5L14.5 9.5V7.5C14.5 6.47 14.5 5.5 16.5 5.5H18V2.14C17.674 2.097 16.443 2 15.143 2C12.428 2 10.5 3.657 10.5 6.7L10.5 9.5H7.5L7.5 13.5H10.5L10.5 22H14.5L14.5 13.5Z",
    fill: "#2F2D26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRifacebookfill);
export default __webpack_public_path__ + "static/media/rifacebookfill.2e0fa282ac336356d21d1a74423237aa.svg";
export { ForwardRef as ReactComponent };